import cover from "../../assets/pic1.png";
export const source = () => {
  const result = [
    {
      title: "Waxaa diyaariyay",
      details: {
        html: `
        <h4>Waxaa diyaariyay</h4>
        <ol>
        <li>Dr Mengistu Gebreyohanes, Dhakhtarka Lafaha, Khabiirka
        Qaliimada laf dhabarta.</li>
        
        <li>Dr Ephrem Gebrehana, Dhakhtarka Lafaha, Khabiir-hoosaadka
        Dhaawaca iyo Arthroplasty</li>
      </ol>
      <div style="padding-left: 30%;">
      <p>Hawassa Itoobiya<br> 2016 G.C</p>
      </div>
      <table>
  <tr>
    <th>Aalada waxa sameeyay</th>
    <th>Waxaa qarashgareeyay</th>
    </tr>
    <tr>
    <td>Ermias kurabachew<br>+251 92 250 0469</td>
    <td>AO Alliance</td>
    </tr>
    </table>

    `,
      },
      image: "bosad_poster",
    },
    {
      title: "Xuquuqda daabacaadda",
      details: {
        html: `
        <h3>Xuquuqda daabacaadda 2023 ee Kooxda Cilmi-baarista BOSAD ee Itoobiya.
        Dhammaan xuquuqaha way xifdiyeen</h3>
      <h4>All right reserved 2023 G.c</h4>
      <p style="padding-right: 10px;">
        Lagu daabacay Itoobiya. <br />
        Marka laga reebo sida uu dhigayo bayaanka 410/2004, sida lagu bedelay xeer
        Lr. 872/2014, qayb ka mid ah daabacaadan lama daabici karo ama lama qay-
        bin karo nooc kasta ama sinaba ama laguma kaydin karo kaydka xogta ama
        nidaamka dib u soo celinta iyada oo aan horay loo qorin ogolaanshaha
        Kooxda Cilmi-baarista ee BOSAD ee Itoobiya.
      </p>
      <p style="padding-right: 10px;">
        Buugan yar wuxuu awooda saaraya dhicida aan kutalogalka aheyn, sida looga
        hortago iyo isbitalka kahor daaweyn tooda caruura iskuulka waxaa diyaariyay
        BOSAD waxaana lagu dhameystiray baaristaan caalamiga ah.
      </p>
      <p style="padding-right: 10px;">Naqshadaynta iyo qaabaynta buug-yaraha: Des Advert Waxaaa turjumay: Sada Hasssan
      </p>
      <p style="padding-right: 10px;">Buugan yar wuxuu awooda saaraya dhicida aan kutalogalka aheyn, sida looga
        hortago iyo isbitalka kahor daaweyn tooda caruura iskuulka waxaa
        diyaariyay BOSAD waxaana lagu dhameystiray baaristaan caalamiga ah.
      </p>
      <p style="padding-right: 10px;">
      Haddii aad rabto inaad bixiso talo ama jawaab celin, fadlan isticmaal ci- waanka soo socda. Dr. Mengistu Gebreyohanes; lambarka taleefanka:
      +251910120423 ama ciwaanka iimaylka: mengistugmengesha@gmail.com      
      </p>`,
      },
    },
    {
      title: "Ictiraaf",
      details: {
        html: `
        <p style="padding-right: 20px;">
        Anaga oo ah qoraaga buug-yaraha ardayda dugsiyada, waxa aanu mahad naq u siinaynnaa kooxda cilmi-baadhista ee BOSAD ee Itoobiya oo si firfircoon uga qayb qaatay helista xogta qaranka. Waxaan sidoo kale ka mahadceliney- naa dadaalka turjubaanka xirfadlayaasha ah ee sida xirfadda leh ugu turjumay shaqada asalka ah luqado kala duwan, oo ay ku jiraan Amxaari, Afaan Oromo, Sidaamu Afoo , iyo Somali. Ugu dambayntii, waxaanu qiraynaa wax-qabadkii Drs. Xizkyas Kassaye , Araya Tilahun , Tolasa Diinsa , Abdullahi Mohamed , iyo Mrs. Eden Alemu (isku-duwaha waxbarashada BOSAD).
      </p>
      <ol>
        <li>
          Dr. Mengistu Gebreyohanes Mengesha,
          <span>Dhakhtarka Lafaha, Khabiirka Qaliimada laf dhabarta.</span>
        </li>
        <li>
          Dr. Ephrem Gebrehana Adem,
          <span>Dhakhtarka Lafaha, Khabiir-hoosaadka Dhaawaca iyo Arthroplasty</span>
        </li>
      </ol>`,
      },
    },
    {
      title: "HORDHAC",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Marka la eego maqnaanshaha agab waxbarasho oo diiradda saaraya ka hortagga dhicitaanka aan ula kac ahayn iyo bixinta daryeelka isbitaalka ka hor carruurta da’da dugsiga, tirada carruurta ay la kulmaan shilalka dhicis waa nasiib darro caadi ah. Si loo soo afjaro farqigaas, buug-yarahaan waxaa lagu soo saaray luqado kala duwan oo ay sameeyeen khubaro ku lug leh cil- mi-baarista qaran ee xarumaha badan ee la yiraahdo Bone Setting Associ- ated Disability (BOSAD) ee itoobiya iyo Gambiya. Ujeedada daraasaddan ayaa ah in laga hortago dhibaatooyinka ka yimaada dhaawacyada muruqya- da ee lagu maareeyo faashad adag, kabidda alwaaaxa(baambo) iyo duugis soo noqnoqda. Ujeedada oo dhan ee kooxdan cilmi-baadhaha BOSAD waa in la horumariyo daryeelka dhamaystiran ee la siiyo dhammaan dhaawacya- da murqada iyo lafaha ee dalka oo dhan.
        </p>
        <p style="padding-right: 10px;">
        18-kii bilood ee la soo dhaafay ee daraasadda, carruur badan oo da’ dug- siyeedka gaaray ayaa la kulmay shilal ku dhacay dugsiga. Ka dib, waxa    la geeyey lafo-dhaqameedka u dhow halkaas oo ay ka heleen kabyo bam- boo, duugis, oo ay guriga joogeen 7 ilaa 14 maalmood . Dabadeed markii ay xanuunka ka nasan waayeen, qoyskiina la ogaaday in xaaladdu ka sii darayso, waxay keeneen xarumaha caafimaadka si ay u qiimeeyaan oo ay  u maareeyaan. Marka la qiimeeyo midkoodna waxay yeelan doonaan lug quruntay (gangrenous) ah oo aan la badbaadin karin waxayna ku dhamaan- aysaa goynta ama dhaawac aan laga soo kaban karin oo joogto ah kaas oo isu baddeli doona to kadhalan doonta naafo joogto ah. Dhakhtarka lafaha ahaan tani waa runta xun ee aan la kulanno hawl maalmeedkeena. Haddii carruurta waqtigeeda loo soo bandhigo xarumaha caafimaadka oo si hab- boon loo maareeyo ka dib markii ay dhaawacmaan, way fiicnaan lahayd in si habboon loo maareeyo waxayna dib ugu laaban doonaan waxbarashadoodii iyagoo caafimaad qaba.
        </p>
        <p style="padding-right: 10px;">
        Dhiirigelinta aasaasiga ah ee ka dambeysa diyaarinta buug-yarahaan carruurta dugsiga waa in kor loo qaado wacyiga ku saabsan dhaawacyada soo dhacaya iyo bixinta xeelado ka hortag ah. In kasta oo dhicitaanku aan had iyo jeer laga fogaan karin, hubinta xirmo badbaado leh oo ku habboon car- ruurta dhaawacan waxay si weyn u yareeyn kartaa dhaawac kale waxayna soo dedejin kartaa soo kabashada. Buug-yarahaan carruurta dugsigu wuxuu qeexayaa maaraynta dhamaystiran ee isbitaalka kahor ee carruurta dhaawa- can, taasoo u sahlaysa macalimiinta dugsiga, qoysaska, iyo carruurta laftoo- da inay fahmaan oo dabaqaan tallaabooyinkan haddii ay dhacdo dayri.
        </p>
        <p style="padding-right: 10px;">
        Sida aynu wada ogsoonahay caruurtu maaha dad qaangaar ah oo yar. Waxay leeyihiin awoodo jireed iyo garasho oo kala duwan, heerar ku tiirsanaan, waxqabadyo iyo dhaqamo halis ah marka loo eego dadka waaweyn. Si- daa darteed, buug-yarahaan madaxa-bannaan wuxuu si gaar ah diiradda u saarayaa dhaawacyada dhicitaanka carruurta dugsiga.
        </p>
      </div>
      `,
      },
    },
    {
      title: `UJEEDADA BUUG-YARAHA`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Ujeedada ugu weyn ee buug-yar- ahan waa in la siiyo macluumaad- ka carruurta dugsiga laftooda, qoysaska, macalimiinta dugsiga, daryeelayaasha, shaqaalaha war- baahinta dugsiga sida mini-media iyo dhammaan bulshada qayba- heeda kala duwan oo ku saabsan arrimaha khatarta ah ee dhaawacyada carruurta ee dugsiga ku dha- caya, sida looga hortago iyo habka maamulka inta badan ee daryeelka ka hor isbitaalka. Buug-yarahaan waxaa lagu turjumay luqado kala duwan oo Itoobiya ah waxaana loo qaybiyaa dugsiyada iyo qoysaska haddii ay suurtagal tahay.
        </p>
      </div>  `,
      },
    },
    {
      title: `QEEXITAANNO`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
          <b>Carruur:-</b> Buugyarahan, waxaan ku isticmaalnay ereyga “carruur” si aan u tixraacno shakhsiyaadka ka yar da’da 18 sano. Sida caadiga ah, dham- maan carruurta dhigta fasalkooda ilaa fasalka 12aad waxay ku ji- raan dallada carruurta.
        </p>
        <p style="padding-right: 10px;">
          <b>Ku dhaca ama ku dhaca shil:-</b> Waa mid aan qorshaysnayn oo si lama filaan ah ugu soo degay dhulka, dabaqa iyo heerka hoose taas oo keeni karta dhaawac shakhsi ah.
        </p>
        <p style="padding-right: 10px;">
          <b>Dhaawac ama dhaawac:-</b> Buugyarahan, ereyada “dhaawac” iyo “trau- ma” ayaa si isweydaar ah loo istcmaalay si ay u muujiyaan waxyeelada jireed ee soo gaarta unugyada nool ee jirka oo keenay dhaawacyada aan kutalogalka aheyn.
        </p>
      </div>  `,
      },
    },
    {
      title: `MAXAY MUHIIM U TAHAY KAHADALKA DHAAWACYA- DA AAN KUTALOGALKA AHEYN CARUURTA DUGSIGA`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>
          Sida laga soo xigtay warbixinta WHO, carruurta ilaa da’da 18 jir,
          dhaawacu waa mid ka mid ah 3da sababood ee ugu sarreeya ee
          sababa dhimasha iyo naafanimada joogtada ah.
          <li>
          Inta badan wadamada kheyraadka xaddidan, dhicitaanku waa
          nooca ugu badan ee dhaawaca caruurnimada ee lagu arko waaxyaha xaaladaha degdegga ah, taasoo ka dhigan 25 - 52% dhammaan hababka dhaawacyada.
          </li>
          <li>
            Mid ka mid ah sababaha ugu waaweyn ee ka-tagitaanka dugsiga waa
            cudurrada la xiriira xanuun jiitama iyo naafanimada joogtada ah.
          </li>
          <li>
          Dhicisyo keenaya kharashyo bulsheed iyo dhaqaale oo sarreeya
          qoysaska iyo bulshooyinka guud ahaan isbitaal dhigista awgeed.
          </li>
          <li>
            Dhicistu waa sababta afraad ee dhimashada naxdinta leh ee
            caruurnimada Maraykanka taas oo aad uga sii dari doonta dalkeena
            oo 3 jeer ka badan.
          </li>
          <li>
          Waayo-aragnimadeena ka jirta Itoobiya, bukaannada carruurtu
          waa kuwa ugu dhibka badan ka dib markii ay shil galeen. Ku
          dhawaad 17 % lug goynta lugaha ee lagu sameeyay jaamacada
          Hawassa 3dii sano ee la soo dhaafay waxa ay ku dhacdaa bukaanada caruurta kadib markii ay soo gaareen dhaawacyo fudud
          oo ay faashad adag ku xidhaan ayna yeeshaan lugaha qurunta
          (gangrenous).
          </li>
        </ol>
      </div>
          `,
      },
      image: 1,
    },
    {
      title: `WAA MAXAY SABABTA EEY CARUURTA USOO GAARAN DHICID AAAN KU TALO GAL AHEYN?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        kuftinta waa qayb caadi ah oo ka mid ah habka uu ilmuhu u korayo oo u
        korayo - barashada socodka, fuulitaanka, orodka, boodada iyo sahaminta
        deegaanka jireed. Nasiib wanaag, dhicitaannada badankoodu waxay yeelan doonaan natiijooyin yar oo carruurta badankoodu waxay ku dhacaan
        marar badan noloshooda iyaga oo aan lahayn waxyeello weyn marka
        laga reebo dhowr nabar iyo nabarro yar. Waxa jira meelo la doortay oo
        uu ilmuhu ku dhici karo shil ku dhaca dugsiga oo ay ka mid yihiin:
        </p>
        <ol type="1">
          <li>
            Carruurta yaryari waxa laga yaabaa inay ka dhacaan qalabka daryeelka
            ilmaha sida <b>alaabta guriga lagu xannaaneeyo iyo ilmaha socod-baradka</b>
          </li>

          <li>Qaar kale ayaa laga yaabaa inay ka dhacaan
            <b>qalabka garoonka ciyaarta</b>
          </li>

          <li>Ka soo dhaca <b>Saqafka sare</b>
          </li>

          <li><b>Meelaha sibiqsan ama qoyan</b>ayaa si gaar ah u dhaca xilliyada roobabka
          </li>

          <li><b>Koritaanka jaranjarada</b> oo ka boodo soo dhicidda daaqada furan
          </li>

          <li> <b>dhisme cusub oo kusoo dhaca </b>dugsiga
          </li>

          <li><b>Ku dhaca godadka iyo ceelasha </b>dugsiga
          </li>

          <li><b>isboortiga iyo madadaalada</b> sida kubbadda cagta, kubbadda lalis- ka, iyo kuwa kale
          </li>

          <li><b>Ka soo dhaca geed </b> - canuga waxa laga yaabaa in uu geed fuulo si uu midho u
              ururiyo ama uu kuciyaaro kadibna kadhaco
          </li>

          <li>
            Ka soo dhaca <b>dhabarka xayawaanka </b>sida faraska - dhulka miyiga
            ah, waxaa jira suurtogalnimada in carruurtu ay fuulaan faras ama
            dameer oo la soo bandhigo ka dib markii ay soo gaarto dhaawac.
          </li>

          <li>
            Dhaawacyada ay sababaan wax ka qabashada ama qalloocinta asxaabta ay
            isku da’da yihiin, gaar ahaan aagga canqowga, ayaa aad u badan.
          </li>

        </ol>
      </div>
          `,
      },
      image: 2,
    },
    {
      title: `WAA MAXAY CAWAAQIBTA KA DHASHA DHAAWACYADA?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
          Cawaaqibta dhaawaca dhicitaanku waxay ku xirnaan doontaa arrimo kala duwan
          oo ay ku jiraan da’da ilmaha, dhirirka meesha ama tamarta jugta,xawaaraha ,
          oogada dhulka, iyo da- beecadda dhaawaca (ama furan- waxy yeelan doontaa
          dhiigbax dibadda ah ugu yaraan ama dhaawac xiran.
          -dhiig la’aan). Dhaawacyadani waxay yeelan karaan naafo cimrigooda oo dhan
          ah taasoo culeys weyn ku noqon doonta qoysaska iyo bulshada guud ahaan,
          marar yarna, waxay sababi doontaa dhimasho.
        </p>
        <p>
          Inta uu le’eg yahay dhaawaca soo dhicistiisa waxa ka mid ah noocyada soo
          socda:
        <ol type="1">
          <li>Dhaawac maskaxeed oo naxdin leh oo keeni kara miyir beelid</li>
          <li>Dhaawaca laf dhabarta kaas oo keeni kara naafo joogto ah</li>
          <li>Naafada joogtada ah ee cimriga oo ay ku jirto goynta</li>
          <li>Jabka addimada (Jajabka sare iyo/ama hoose)</li>
          <li>Jabka furan oo ku adkaan doona caabuqa</li>
          <li>Dhaawaca saxanka kobaca ee u horseedaya curyaaminta xagasha iyo
            naafanimada joogtada ah ilaa wakhtigeeda lagu maareeyo</li>
          <li>Uur kujirta, miskaha iyo dhaawaca laabta</li>
          <li>Maqalka iyo luminta aragga oo aan dib loo celin karin taasoo qayb ka
            ah naafonimo joogto ah</li>
          <li>Ugu dambeyntii, waxaa sidoo kale jiri kara dhimasho ka timid dhaawac
            sare oo tamar ama hoos u dhac weyn.
          </li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 3,
    },
    {
      title: `SIDEE LOOGA HORTAGI KARAA DHAWACYADA AAN KU- TALOGALKA AHEYN IYO DHIBAATOYINKA KADASHA?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Kahortaggu waa habka ugu wanaagsan ee wax ku oolka leh ee loo maareeyo
        dhammaan xaaladaha caafimaadka la xiriira. Halkan, waxaan isku daynay
        inaan muujino waxqabadyada laga qaban karo heerka dugsiga si looga hortago dhaawacyada waaweyn ee la xiriira dhaawacyada iyo bixinta daawaynta qiimaha wax ku oolka ah ee dhammaan
        </p>
        <ol type="1">
          <li>Sida ugu badan ee suurtogalka ah, dugsigu wuxuu u baahan yahay inuu
            diyaariyo dhismo dugsi <b>“carruur saaxiibtinimo” </b>. Marka aynu
            nidhaahno carruurta saaxiibtinimada dugsiga, uma baahna dhisme aad u
            casri ah, laakiin waxay u baahan tahay inay ka dhigto xarunta mid aad
            u fudud in la dhex maro oo badbaado u ah carruurta, si aan u
            yaraynno shilalka dhicida ee alaabta guriga iyo qalabka ilmaha
            kulugeyo
          </li>
          <li>Marka garoommada ciyaaraha
            <span class="p">(fuulaynta, boodboodka iyo qal- abka sibidhka) ee dugsiga la
              diyaariyo oo la rakibo, waxay u baahan yihiin in lagu qiimeeyo
              heerka badbaadada ka hor inta aanu bilaabin adeeg bixinta, si aanu
              ilma kasta u dhicin si aan loo baahnayn oo aanu u dhaawacmin.
              Dugsigu waxa uu u baahan yahay in uu yeesho hannaan uu ku ilaalinayo
              goobta ciyaarta xilliyada qaarkood oo waxa uu
              u baahan yahay in uu u diro kormeerayaal carruurta yaryar. Dhererku
              waa inuu ku habboon yahay da’da ilmaha; iyo soo degitaanka garoonka
              ciyaarta waxay u baahan yihiin in la hubiyo joogtaynta, badbaadada,
              degitaanka oo siman.</span>
          </li>
          <li>Waxa habboon in dugsiyadu aanay yeelan saqaf furan oo ay carruurtu aadi karaan oo ay si lama filaan ah ugu dhici karaan. Waxaa si adag
          lagula talinayaa in la ilaaliyo saqafka sare, balakoonka iyo jaranjarooyinka si looga hortago dhicitaan shil ah oo ku yimaada carruurta.
          Waxa kale oo muhiim ah in ardayda la baro waxa la samaynayo
          iyo waxa aaan lasameeyneynin ee ku saabsan ammaankooda gudaha
          dhismaha dugsiga iyada oo la adeegsanayo warbaahinta yaryar iyo
          isu imaatinka subaxda ama fiidkii.
          </li>
          <li>Dhismaha dugsigu wuxuu u baahan yahay inuu ahaado nadiif iyo
          engegan intii suurtogal ah iyadoo la saarayo dhulka biyaha leh sida
          bullaacadaha furan iyo ceelasha. Meelahan furan ee biyuhu aad
          bay khatar u yihiin sababta oo ah dhicitaanka waxaana laga yaabaa
          inay qof walba u horseedi karto xaalad naf-gooyo ah. Markaa, waa
          muhiim in laga saaro meel kasta oo simbiriirixan leh oo ku taal
          xayndaabka dugsiga intii suurtogal ah iyadoo la daboolayo ceelasha
          iyo godadka.
          </li>
          <li>Jaranjarada ay carruurtu fuuli jireen waa in la hubiyo badbaadada
          iyo dayactirka si joogto ah ka hor intaysan wax dhaawac ah geysan.
          </li>
          <li>Marka uu dhismo cusub ka jiro dhismaha dugsiga, waa in uu jiraa
          aag mamnuuc ah oo ardaydu aanay u soo dhowaanin iyagoo muujinaya tilmaamo qoran. Taas waxa dheer, waxa kale oo muhiim ah in
          loo diro kormeere si joogto ah ula socda haddii uu jiro arday aado
          aagga khatarta ah ee mamnuuca ah.
          </li>
          <li>Inta lagu jiro nashaadaadka isboortiga ama madadaalada , waxaa
          lagula talinayaa ardayda inay la ciyaaraan facooda da’da u dhigma
          si loo yareeyo dhaawaca sare. Goobta madadaalada waa inay ahaato
          mid badbaado leh oo leh dhul siman. Mar kasta oo la dabaqi karo oo
          ay suurtagal tahay, ardaydu waxay u baahan yihiin inay isticmaalaan
          qalabka badbaadada ee habboon inta ay ciyaarayaan sida jilbaha,
          suxullada, ilaalinta curcurka, iyo koofiyadaha marka ay ciyaarayaan
          ciyaaraha
          </li>
          <li>Carruurta qaarkood waxay isku dayi doonaan inay fuulaan geedaha
          si ay u ururiyaan miraha iyo khudaarta waxayna si shil ah u dhacaan.
          kuwo kale ayaa laga yaabaa inay geedo u fuulaan si ay ula ciyaaraan
          facooda oo naloo soo bandhigo dhaawac addin ah oo caadi ahaan
          jaban. Si kastaba ha ahaatee ujeeddada fuulista geedka, waa in laga
          mamnuucaa carruurta ilaa ay si toos ah u kormeeraan kormeeraha
          dugsiga ama shaqaale kale oo mas’uul ah oo ammaan ah inay fuulaan.
          </li>
          <li>Carruurta , gaar ahaan kuwa da’da yar waa in aan loo oggolaan inay
          fuulaan faras ama dameer. Waxay u baahan yihiin in la baro khatarta
          la xiriirta haddii ay sii jiraan dayrta taasoo xitaa horseedi karta dhimasho naafonimo joogta ah.
          </li>
          <li>Way fiicnaan doontaa in la ilaaliyo dhammaan daaqadaha dugsiga
          si aanu ilmuhu isku dayin inuu si badheedh ah ama ula kac ah uga
          boodo daaqadda oo aanu u dhaawacmin. Imika maalmaha rakibida
          ilaaliyaha daaqaduhu waxay fashion u noqotay dhammaan albaabbada daaqadaha dugsiga waxayna door weyn ku leedahay yaraynta
          dhaawaca dhicista.
          </li>
        </ol>
      </div>
          `,
      },
      image: "4Somali",
    },
    {
      title: `XIRMADA DAAWEYNTA ISBITAAL KA HOR EE LOOGU TALAGALAY ILMAHA KU DHACAY DUGSIGA`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Marka ilmuhu uu soo gaadho dhaawac dhicis, tallaabo degdeg ah oo ay qaadaan kuwa ag taagan ayaa noqon doona lama huraan si loo ilaaliyo nolosha
        ilmaha, yaraynta dhaawaca dheeraadka ah, yaraynta xanuunka, ka hortagga
        itaaldarrada joogtada ah iyo bixinta taageero nafsiyeed. Gargaaar degdega
        ah, oo loo yaqaan “ First Aid,” ayaa door muhiim ah ka ciyaarta ilaalinta
        nolosha ilmaha iyo kor u qaadida natiijooyinka xiga.
        </p>
        <p>
        Si loo helo gargaarka degdega ah ee wax ku oolka ah ee dugsiyada dhexdiisa, waa muhiim in la helo shaqaale tababaran oo ku filan oo si sahal ah loogu
        heli karo goobta oo sita qalabyada gargaarka degdegga ah mar kasta. Sameynta xarumaha gargaarka degdegga ah iyo hubinta in dhammaan dugsiyada
        laga helo shaqaale tababaran waa muhiim. Xarumahani waa in ay mudnaan
        siiyaan jawaabta degdega ah iyo tallaabooyinka gargaarka degdegga ah ee
        aasaasiga ah, iyada oo aan lagu tiirsanayn qalab ama qalab casri ah.
        </p>
        <p>Hawlaha soo socdaa waa in la sameeyaa si loo siiyo gargaarka degdega ah
        ee guuleysta ardayga ku dhaca shilka:
        </p>
        <ol>
          <li>Haddii ay dhacdo in ilmuhu dhaco, jawaab-bixiyeha degdega ahi waa
          in uu si qaylo ah u muujiyaa (Qaylo) gargaar, isaga oo u digaya kuwa
          u dhow inay abaabulaan gargaar. Isla mar ahaantaana, jawaab-bixiyuhu waa in uu la tagaa ilmaha isaga oo isticmaalaya agabka la heli
          karo. Haddii shaqsi loo tababaray gargaarka degdegga ah uu joogo,
          gargaarkooda degdegga ah waa muhiim. Daqiiqado gudahood, tillaabooyinka nafaha lagu badbaadinayo sida meelaynta habboon ee
          ilmaha, qiimaynta marin-haweedka, neefsashada, iyo yaraynta xaalad
          kasta oo nafta halis gelinaysa waa in la bilaabo.
          </li>
          <li>Marka la xaqiijiyo in aysan jirin xaalado naf-gooyo ah oo degdeg ah,
          waa in la sameeyaa sahan guud oo jirka oo dhan ah. Ilmuhu waa in la
          dhigaa meel fidsan, oo ku habboon looxa laf dhabarta haddii la heli
          karo, iyadoo lagu dhiirigelinayo inuu muujiyo goobta dhaawaca ama
          aagga xanuunka ugu badan. Baadhitaankan dhamaystiran waa inuu
          koobaa qiimayn madax-ilaa-lugo, iyadoo la higsanaayo in lagu ogaado dhaawac kasta oo qarsoon ama aan la dareemin oo laga yaabo inaanu ilmuhu markii hore shaaca ka qaadin.
          </li>
          <li>Si loo ogaado jabka addimada ee dhaawacyada murqaha iyo lafaha,
            qiimeeyuhu wuxuu shaqaaleysiin karaa tilmaameyaal caafimaad oo gaar
            ah, oo loo yaqaan “ calaamadaha la hubo ee jabka,” oo ka kooban
            natiijooyinka soo socda:
          <ol type="a">
            <li>Xanuun daran oo ku yaal goobta dhaawaca<br>
            <li>Naafo la arki karo iyo gaabin addimada marka loo eego dhinaca aan
            wax gaarin<br>
            <li>Jajab dibadeed oo muuqda (jab furan)</li>
            <li>La ogaan karo ama la maqli karo dhawaaq cadeeynayo inuu jab jiro(kafogow inaad riixdo si loo yareeyo
            dhaawac xididka iyo
            neerfaha)</li>
            <li>Dhaqdhaqaaq aan caadi ahayn oo ka socda goobta dhaawaca. Haddii
            ilmuhu muujiyo mid ka mid ah calaamadahan, bixinta degdegga ah ee
            gargaarka degdegga ah waa lama huraan, iyo u gudbin degdeg ah
            xarun u qalabaysan in lagu maamulo adeegyada ku habboon ee lafaha
            ayaa noqon doona muhimka ah.</li>
          </ol>
          </li>
          <li>Marka la aqoonsado goobta dhaawaca lagana shakiyo jab ama dhaawac
            jilicsan, shaqaalaha dugsigu waa inay si degdeg ah u ogeysiiyaan
            qoyska ilmaha. Isla mar ahaantaana, xubinta dhaawacantay waa in si
            habboon loo kabo iyadoo lagu salaynayo goobta dhaawaca. Ka
            faa’iidaysiga agabka la heli karo ee ku dhex jira xayndaabka dugsiga,
            hababka kabidda ku meel gaadhka ah ayaa la adeegsan karaa si loo
            hagaajiyo addimada si wax ku ool ah .
          </li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 5,
    },
    {
      title: `MAXAAD SAMEYNAYSAA MARKA AAD SIINAYSO GAR- GAARKA KOOWAAD EE ILMAHA SOO DHACAY?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Talaabooyinka soo socdaa waa muhiim si ay si wax ku ool ah u dhaqaa-
          jiyaan qaybta jidhka ee dhaawacantay ee ilmaha la kulmay shil dhacay:</p>
        <ol type="a">
          <li>Haddii ay dhacdo dhiigbax, isticmaal tuwaalada la heli karo ee
            xirmooyinka gargaarka koowaad si aad u joojiso dhiigga. Marka ay
            maqan yihiin, dharka ilmaha ama labiskiisa waa la isticmaali
            karaa. Mudnaanta sii si aad u joojiso dhiigbaxa welwelka kahor
            laga qabo caabuqa iman kara. Markaad codsanayso tuwaalka, hubi
            inay u shaqeyso sidii dhaymo weyn, iska ilaali duubab adag oo
            carqaladayn kara wareegga oo ka sii dari kara isu-tanaasulka wareegga dhiigga. Inta lagu jiro nidaamka si
            loo joojiyo dhiigbaxa,
            qaado taxaddar si aad uga hortagto wasakheynta shakhsi ahaaneed ee
            dhiigga
          </li>
          <li>Inta ugu badan ee suurtogalka ah, ka saar dhammaan dharka ku
            wareegsan xubinta dhaawacantay ee ilmaha.
          </li>
          <li>Haddii uu jiro shaki laga qabo dhaawac laf dhabarta (dhabarka),
            ilmuhu waa inuu ahaadaa mid dhaqdhaqaaq la’aan ah ilaa lagu nadiifiyo cusbitaalka. Dhaqaaqidda ama
            girgilinta ubadka waxay sii
            kordhin kartaa dhaawaca.
          </li>
          <li>Iska ilaali inaad isku daydo riixdo ama aad toosiso ilaa uu jiro
            naafo oo muuqata. Taas oo la sameeyo waxay keeni kartaa dhaawac
            dheeraad ah oo aan loo baahnayn waxayna u geyn kartaa xanuun
            daran ilmaha. Taa beddelkeeda, dhaqdhaqaajin ka geli xubinta
            meesha ay hadda joogto. Haddii aysan jirin dhaqdhaqaaq, dareen,
            ama garaaca garaaca goobta dhaawaca, tixgeli in yar oo dib u
            habeyn ah oo addinka ah si loo fududeeyo shaqada dareemayaasha iyo
            wareega dhiiga.
          </li>
          <li>Markaad taageero siinayso xubinta dhaawacantay, caawimaad karaadso qof u dhow si uu uga caawiyo inuu
            dhaqdhaqaaqi waayo.
          </li>
          <li>Waxaad isticmaali kartaa shay kasta oo toosan oo adag sida loox
            alwaax ah, ulo adag, kartoonno, ama kartoon si aad u kabto. Arrinka muhiimka ah waa in la hubiyo in
            kabashadu ay si habboon u
            cabbiran tahay si ay ugu habboonaato addimada dhaawacantay.
          </li>

          <li>Markaad ku xereyso jeesada ujeedadu waa inaad ku xertaa isgoosyska sare iyo kan hoose waana inaad ilaalisa
            dhaqaaqa xubinta
            jaban.
          </li>

          <li>Iska ilaali inaad isticmaasho faashad adag ama duub oo ka sii dari
            karta wareegga dhiigga
          </li>
          <li>Inta lagu jiro kabidda, hubi in 10-15 darajo laabasho ah ee
            wadajirka jilibka, xagal 90-degree ah oo ku yaal anqawga iyo
            suxulka, oo ilaali meel toos ah sinta iyo curcurka.
          </li>
          <li>Hubi kabyada adigoo duubaya ama ku xidhay addinka dhaawacmay.
            Waxaad isticmaali kartaa maradii hore ee laga saaray si aad ugu
            xidho kabka meesha.
          </li>
          <li>Diyaarso u gudbinta degdega ah ee ilmaha meesha ugu dhaw eey
            kaheli karaan gargaar deg deg ah, caafimaadka ee dhow halkaas oo
            ay ka heli karaan maamul caafimaad oo qeexan.
          </li>
          <li>Way fiicnaan lahayd haddii qof goob joog u ahaa dhicitaanka ubadka ama ku lug lahaa maamulka gargaarka
            degdegga ah uu raaco ilmaha
            oo u fududeeyo ku wareejinta bixiyaha adeegga daryeelka
            caafimaadka.
          </li>
        </ol>
      </div>
          `,
      },
      image: 6,
    },
    {
      title: `MAXAAA AHEYN INAAD SAMEEYSO MARKA AAD BIX- INEEYSO GARGAARKA DEGDEGA ILMAHA SOO DHACAY?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>Ha dhayalsan dhaawaca soo dhaca carruurta.
            <span class="p">Ilmo kasta oo la kulma kor ka soo dhicis, joogteeyo
              dhaawaca inta lagu jiro dhaqdhaqaaqyada isboortiga, ama
              saamaynta tamarta sare leh, oo ay weheliso cabashooyinka
              xanuunka goobta dhaawaca ama ooyaya shilka ka dib, waa
              muhiim in aan la dhayalsan dhaawaca oo loo diro ilmaha
              guriga. Qaab dhismeedka lafaha carruurtu aad ayuu uga duwan
              yahay dadka waaweyn, taasoo ka dhigaysa inay aad ugu nugul
              yihiin noocyada soo socda ee jabka carruurta ee gaarka
              ah:</span>
          <ol type="a">
            <li>Dhaawacyada saxanka koritaanka</li>
            <li>Jajabka aan dhameeystirneeyn</li>
            <li>Jabka aan muuqan </li>
            <li>Toosinta qalooca. Qaababkaan jabka ayaa ka duwan jabka
            dadka waaweyn. Sidaa awgeed, ilaa uu meesha ka saaro
            dhakhtarka lafaha , kiisaska noocaas ah waa in lagu
            daaweeyaa iyada oo loo maleynayo in ilmuhu uu jaban karo.</li>
            </ol>
          </li>
          <li>Ha duugin, ha ku dhaqmin ama ha u dirin ilmaha dhacay
            hab-dhaqameedyada.
            <span class="p">Dhammaan carruurta ku dhacda dhaawac dhicis waa in lagu
              qiimeeyaa dhakhtarka lafaha oo si habboon u tababaran .
              Carruurtu waxay si fudud ugu suurtagashaa dhibaatooyin ay ka
              mid yihiin gangrene, dhaawaca xididdada dhiigga, qallafsanaanta iyo malunion . Intaa waxaa dheer, jabka
              carruurtu way
              adag tahay in la ogaado oo la garto ilaa si sax ah loo raajo
              oo ay baaro xirfadlayaal caafimaad oo tababaran. In la isku
              dayo in la duugo ama la dhaqaajiyo qaybta ay saamaysay ee
              jidhka ilmaha ayaa ka mid ah xanuunnada ugu xun ee uu qofku
              la kulmo noloshiisa, waxaana laga yaabaa inay keento miyir
              beelid. Wax-is-daba-marinta noocan ah waa in gabi ahaanba la
              mamnuucaa.</span>
          </li>
          <li>Ha isticmaalin faashad adag.
            <span class="p">Ku dhejinta faashad adag oo lagu dhejiyo addinka hore u
              dhaawacmay waxay si weyn u wiiqi kartaa wareegga, taasoo u
              horseedi karta xubin gangrenous ah. Sidaa darteed, mar kasta
              oo ay suurtagal tahay, kabyada waa in ay ka fogaadaan
              codsiga wareegtada ah oo si dabacsan loo rakibo si ay u
              taageeraan addinka.</span>
          </li>
          <li>Ha isticmaalin tourniquet (qalab dhiiga lagu joojiyo) si aad u
            joojiso dhiigbaxa.
            <span class="p">Codsiga torniquet si loo joojiyo dhiigbaxa addinka
              dhaawacan ayaa wax u dhimi doona socodka dhiigga. Marka, mar
              kasta oo aad qorsheyneyso inaad joojiso dhiigbaxa, kaliya
              mari dhaymo weyn iyo sare u qaadida cirifka. Kadibna isla
              markiiba u gudbi bukaanka xarumaha caafimaadka.</span>
          </li>
        </ol>
      </div>
          `,
      },
      image: 7,
    },
    {
      title: `AYO, GOORMA, SIDEE LOOGU DIRAAA ILMO SOO DHACAY ISBITAALKA?`,
      details: {
        html: `
        <div class="chapter-content">

        <p>Yaa loo tixraacaa?
          <span class="s11">Dhammaan ilmaha uu ku dhaco dhaawac hoos u dhaca oo haysta mid ka mid
            ah kuwan soo socda waa in si degdeg ah loogu gudbiyo xarumaha
            caafimaadka:</span>
        </p>
        <ol type="1">
          <li>Dhaawac kasta oo dhiigbaxa ka dib dhaawaca</li>
          <li>Joogitaanka mid ka mid ah calaamadaha la hubo ee jabka ee aan kor ku
            soo sheegnay</li>
          <li>Haddii aad ka shakisan tahay qof dhaawac gobolka ah</li>
          <li>Jiritaanka xanuunka, jilicsanaanta iyo bararka goobta dhaawaca</li>
          <li>Isticmaalka adkaanta addimada dhaawacantay</li>
          <li>Ilmaha ka yar, haddii ay si joogto ah u ooyaan dhaawaca ka dib</li>
          <li>
            Goorma ayaa loo gudbinayaa ilmaha dhacay?
            <span class="s11">Carruurta dhaawacyadu ka soo gaadhaan dhicitaanku waxay heli doonaan
              gargaar degdeg ah goobta waxayna mari doonaan muddo indho-indhayn gaar
              ah. Kiisaska dhaawacu aanu yarayn oo ilmuhu aanu dib u bilaabi karin
              hawlihii caadiga ahaa sida ku noqoshada fasalka ama ciyaarta, u gudbin
              degdeg ah waa lama huraan. Ku-gudbinta waqtiga ku habboon ee dhaawaca ka
              dib waxay fududaysaa ogaanshaha degdegga ah, waxay hubisaa maaraynta
              hore, waxayna keentaa natiijooyin wanaagsan. Haddaba, iska ilaali dib u
              dhac aan loo baahnayn oo ku saabsan u gudbinta carruurta dhacday si loo
              ogaado waqtiga iyo daryeelka ku habboon.</span>
          </li>
          <li>
            Sidee loo gudbiyaa ilmahan?
            <span class="s11">Ugu horrayn, maamul dhammaan tallaabooyinka gargaarka degdegga ah ee
              naf-badbaadinta nolosha iyo addimada ee suurtogalka ah ee heer dugsi.
              Ka dib, ogeysii qoysaska xaalada ilmaha, una fududayso u wareejinta
              ubadka goob daryeel caafimaad oo ay la socdaan qoyska ama daryeelaha.
              Intaa waxaa dheer, u magacow hal wakiil oo ka socda dugsiga si uu u
              raaco oo u fududeeyo wareejinta xarunta daryeelka caafimaadka.</span>
          </li>
        </ol>
      </div>
          `,
      },
      image: "8Somali",
    },
    {
      title: `MEXEY YIHIIN AALADAHA EE LOO ISTICMAALO XERMOOYINKA DAAWEYNTA SAXDA AH`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Xaaladda ilmaha dhaawacantay, daryeelka saxda ah ayaa ka bilaabmay goobta
          shilku ka dhacay iyada oo ah dhibbanayaal dhaawac ah. Kadibna ubadka ayaa
          loo baahan yahay in loo wareejiyo xarumaha caafimaadka ee ku haboon waana
          in la bixiyaa dhamaan hawlaha caadiga ah oo ay ku jiraan hawlahan waaweyn
          ee soo socda:
        </p>
        <ol type="1">
          <li>Ilmaha waxaa lagu qiimeyn doonaa dhaawac kasta oo nafta halis gelinaya
            waxaana loo maareynayaa si waafaqsan. Habka loogu talagalay bukaan
            kasta oo dhaawac ah ayaa raacaya tilmaamaha taageero nololeed oo
            horumarsan
          </li>
          <li>Dabadeed, iyadoo lagu saleynayo nooca dhaawaca, daawooyin kala duwan sida 
            xanuunka xanuunka, antibiyootiga, teetanada antitoxin,
            iyo daawada suuxdinta ayaa la siin doonaa iyadoo lagu salaynayo
            tilmaanta.
          </li>
          <li>Haddii uu dhaawac jiro, waxaa lagu nadiifin doonaa si nadiif ah
            waxaana lagu dabooli doonaa faashad nadiif ah ka dib joojinta
            dhiigbaxa.
          </li>
          <li>Mar kasta oo ay jirto qallafsanaan cad iyo kala-bax, waa la dhimi
            doonaa ka dib marka la siiyo daawo ku filan oo habboon si ilmaha looga
            dhigo mid bilaash ah.
          </li>
          <li>Addinka waxaa loo jeesteyn doona si habboon iyadoo la ixtiraamayo
            mabaadi’da kabidda
          </li>
          <li>Kadibna bukaanka ayaa loo diri doonaa sawirka raajada ee habboon.
            Halkan mid ka mid ah waxyaabaha ugu muhiimsan ee aad u baahan tahay
            inaad ogaato waa jabka bukaanka ee carruurta waa mid ka duwan qaababka
            jabka qaangaarka, markaa raajooyinka aan u baahanahay si aan u ogaano
            dhibaatada way ka duwan tahay (labada raajo ee xagjirka ah ayaa loo
            qaadi doonaa isbarbardhigga sababtoo ah Joogitaanka saxan korriin
            furan) iyo tarjumaaddu waxay sidoo kale u baahan doontaa qiimeyn
            qotodheer. Markaa, qof kasta oo arki kara raajada ma dooran doono
            helitaanka qaar ka mid ah dhakhtarka carruurta jab, run ahaantii waxay
            u baahan tahay in khibrad loo yeesho. Maadaama ay jiraan wax badan oo
            lafo-dhaqameed oo u soo bandhiga carruurta dhibaatooyinka aan loo
            baahnayn oo ay ku jiraan gangrene iyaga oo si isdaba-joog ah u duugaya
            oo si adag u faashad (xidhay) ka dib markay dalbadaan raajo iyada oo 
            aan wax tababar ah loo helin sida loo fasiro raaja- da.
            Marka, dhammaan waalidiinta waxaa saaran mas’uuliyadda iyo waajibka ah
            inay hubiyaan in daawaynta la siinayo carruur- tooda dhintay ay tahay
            mid u tababaran xirfadle caafimaad.
          </li>
          <li>Iyada oo ku saleysan jawaabta raajada bukaanka daawada waxeey noqon
            kartaa mid qaliin ah ama mid aan qaliin aheyn in lagu xaliyo .
          </li>
          <li>Guud ahaan, inta badan dhaawacyada carruurta waxaa lagu maareeyaa
            hababka aan qalliinka ahayn kuwaas oo dhab ahaantii u baahan khabiir
            si loogu dabaqo si habboon natiijadana waa wanaagsan tahay. Waxay u
            baahan tahay dabagal dhow, ujeeddada oo dhan ee maaraynta ilmaha
            dhintayna waa in la maareeyo wakhtiga, baxnaanin degdeg ah iyo dib ugu
            soo laabashada dugsiga. Marka la sameeyo waxaas oo dhan, waxaa
            suurtagal ah in la yareeyo ka tagista dugsiga iyo maqnaanshaha.
          </li>
        </ol>
      </div>
          `,
      },
      image: 9,
    },
    {
      title: `Tixraacyo`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>World Health Organization (WHO).Injuries and Inequities-Guidance forAddressing Inequities in
            unintention-al Injuries. Copenhagen, Denmark:World Health Organization RegionalOfﬁce for Europe; 2014</li>
          
          <li>CDC, Injuries among Children andTeens report, https://www.cdc.gov/injury/features/child-injury/index.html
          </li>
          <li>Chapman RL, Buckley L, SheehanM, Shochet IM. Pilot evaluation ofan adolescent risk and injury pre-vention
            programme incorporatingcurriculum and school connected-ness components. Health Educ Res.2013;28(4):612–625
          </li>
          <li>James S.L, Lucchesi L.R, BisignanoC, Castle C.D, Dingels Z.V, et al.The global burden of falls: Global,
            re-gional and national estimates of mor-bidity and mortality from the GlobalBurden of Disease Study 2017.
            InjuryPrev. 2020, 26 (Suppl. 1), i3–i11</li>
          <li>Amy E Peden, Richard C Franklin,Child Injury Prevention: Is it time toaddress the determinants of
            Health.Children, 2021, 8:46.</li>
          <li>International Federation of Red crossand Red crescent Societies, Interna-tional First aid and
            Rescessitationguidelines, 2016</li>
          <li>Meghalaya State Disaster Man-agement Authority, Basic First AidManual, India, 2014</li>
          <li>Blake G, Velikonja D, Pepper V,Jilderda I, Georgiou G. Evaluating an in-school injury
            preventionprogramme’s effect on children’shelmet wearing habits. Brain Inj.2008;22(6):501–507</li>
          <li>Pickett, W.; Molcho, M.; Simpson,K.; Janssen, I.; Kuntsche, E.; Ma-zur, J.; Harel, Y.; Boyce, W.F.
            Crossnational study of injury and socialdeterminants in adolescents. InjuryPrev. 2005, 11, 213–218</li>
          <li>Lama Bou-Karroum, Fadi El-Jardali,Mathilda Jabbour, Aya Harb, RachaFadlallah, et al, Preventing
            Unin-tentional Injuries in School-AgedChildren: A Systematic Review.Paediatrics, 2022, 149:6</li>
          <li>UNICEF. Levels & Trends in ChildMortality Report 2019. New York,NY: UNICEF; 2020</li>
          <li>Jamison DT, Breman JG, MeashamAR, et al. Disease Control Prioritiesin Developing Countries. Washing-ton,
            DC: The World Bank; 2006</li>
          <li>Barcelos RS, Del-Ponte B, SantosIS. Interventions to reduce accidentsin childhood: a systematic review.
            JPediatr (Rio J). 2018;94(4):351–367</li>
          <li>Mytton J, Towner E, Brussoni M,Gray S. Unintentional injuries inschool-aged children and
            adolescents:lessons from a systematic review ofcohort studies. Inj Prev.2009;15(2):111–124</li>
          <li>Mock CN, Smith KR, Kobusingye O,et al. Injury Prevention and Environ-mental Health: Key Messages. 3rded.
            Disease Control Priorities. Vol 7.Washington, DC: The World Bank;2017</li>
          <li>Nauta J, van Mechelen W, OttenRHJ, Verhagen EALM. A system-atic review on the effectivenessof school and
            community-basedinjury prevention programmes onrisk behaviour and injury risk in 8-12year old children. J Sci
            Med Sport.2014;17(2):165–172</li>
          <li>Kendrick D, Mulvaney CA, YeL, Stevens T, Mytton JA, Stew-art-Brown S. Parenting interventionsfor the
            prevention of unintentionalinjuries in childhood. Cochrane Data-base Syst Rev. 2013;(3)</li>
          <li>Towner E, Dowswell T, Jarvis S.Updating the evidence. A systematicreview of what works in
            preventingchildhood unintentional injuries: part1. Inj Prev. 2001;7(2):161–164</li>
          <li>Kendrick D, Young B, Mason-JonesAJ, et al. Home safety education andprovision of safety equipment
            forinjury prevention. Cochrane DatabaseSyst Rev. 2012;(9)</li>
          <li>Pearson M, Garside R, Moxham T,Anderson R. Preventing unintentionalinjuries to children in the home:
            asystematic review of the effective-ness of programmes supplying and/or installing home safety
            equipment.Health Promot Int. 2011;26(3):376–392</li>
          <li>Pearson M, Hunt H, Garside R, Mox-ham T, Peters J, Anderson R. Prevent-ing unintentional injuries to
            children under 15 years in the outdoors: asystematic review of the effectivenessof educational programs. Inj
            Prev.2012; 18(2):113–123</li>
          <li>Orton E, Whitehead J, Mhizha-Mu-rira J, et al. School-based educationprogrammes for the prevention
            ofunintentional injuries in children andyoung people. Cochrane DatabaseSyst Rev. 2016;(12):CD010246</li>
          <li>Morrongiello BA, Lasenby-LessardJ. Psychological determinants of risktaking by children: an
            integrativemodel and implications for interven-tions. Inj Prev. 2007;13(1):20–25</li>
          <li>DelCastillo-Andres O, Toronjo-Hor-nillo L, Toronjo-Urquiza L. Effectsof fall training program on
            autom-atization of safe motor responsesduring backwards falls in school-agechildren. Int J Environ Res
            PublicHealth. 2019;16(21)</li>
          <li>WHO, Falls, Key facts, 2021, https://www.who.int/news-room/fact-sheets/detail/falls</li>
        </ol>
      </div>
          `,
      },
    },
  ];
  return result;
};
